[
    {
        "plugin": "Datagrid",
        "columns_config": {
            "color": {
                "bg_color": "linear-gradient(to right, #ff0000 0%, #ffff00 10%, #00ff00 20%, #00ffff 30%, #0000ff 40%, #000080 50%, #0000ff 60%, #00ffff 70%, #00ff00 80%, #ffff00 90%, #ff0000 100%)",
                "bg_gradient": 251.04,
                "bg_mode": "gradient",
                "fg_mode": "disabled"
            }
        },
        "plugin_config": {
            "editable": false,
            "scroll_lock": false
        },
        "title": "Spreadsheet Cam",
        "group_rollup_mode": "flat",
        "group_by": ["y"],
        "split_by": ["x"],
        "columns": ["color"],
        "filter": [],
        "sort": [],
        "expressions": {
            "New Column 1": "bucket(\"color\", 5)",
            "y": "floor(\"index\" / 80)",
            "x": "-\"index\" % 80"
        },
        "aggregates": {}
    },
    {
        "plugin": "Heatmap",
        "title": "Heatmap Cam",
        "group_by": ["x"],
        "split_by": ["y"],
        "columns": ["color"],
        "expressions": {
            "y": "-floor(\"index\" / 80)",
            "x": "-\"index\" % 80"
        },
        "aggregates": {
            "New Column 1": "any"
        },
        "columns_config": {
            "color": {
                "gradient": "linear-gradient(to right, #ff0000 0%, #ffff00 10%, #00ff00 20%, #00ffff 30%, #0000ff 40%, #000080 50%, #0000ff 60%, #00ffff 70%, #00ff00 80%, #ffff00 90%, #ff0000 100%)"
            }
        }
    },
    {
        "plugin": "Heatmap",
        "plugin_config": {},
        "settings": true,
        "title": "Downsampled Heatmap Cam",
        "group_by": ["x"],
        "split_by": ["y"],
        "columns": ["color"],
        "filter": [],
        "sort": [],
        "expressions": {
            "y": "bucket(-floor(\"index\" / 80), 3)",
            "x": "bucket(-\"index\" % 80, 3)"
        },
        "aggregates": {},
        "columns_config": {
            "color": {
                "gradient": "linear-gradient(to right, #ff0000 0%, #ffff00 10%, #00ff00 20%, #00ffff 30%, #0000ff 40%, #000080 50%, #0000ff 60%, #00ffff 70%, #00ff00 80%, #ffff00 90%, #ff0000 100%)"
            }
        }
    },
    {
        "plugin": "Y Bar",
        "plugin_config": {},
        "title": "Luminosity Histogram",
        "group_by": ["bucket(\"color\", 5)"],
        "split_by": [],
        "columns": ["color"],
        "filter": [],
        "sort": [],
        "expressions": {
            "bucket(\"color\", 5)": "bucket(\"color\", 5)",
            "y": "-floor(\"index\" / 80)",
            "x": "-\"index\" % 80"
        },
        "aggregates": {}
    },
    {
        "plugin": "Datagrid",
        "columns_config": {
            "color": {
                "bg_color": "linear-gradient(to right, #ff0000 0%, #ffff00 10%, #00ff00 20%, #00ffff 30%, #0000ff 40%, #000080 50%, #0000ff 60%, #00ffff 70%, #00ff00 80%, #ffff00 90%, #ff0000 100%)",
                "bg_gradient": 2463.68,
                "bg_mode": "gradient",
                "fg_mode": "disabled"
            }
        },
        "group_rollup_mode": "flat",
        "plugin_config": {
            "editable": false,
            "scroll_lock": false
        },
        "title": "Small Spreadsheet Cam",
        "group_by": ["bucket(y, 5)"],
        "split_by": ["bucket(x, 5)"],
        "columns": ["color"],
        "filter": [["bucket(x, 5)", "<", 0.0]],
        "sort": [],
        "expressions": {
            "bucket(y, 5)": "bucket(floor(\"index\" / 80), 2)",
            "New Column 1": "bucket(\"color\", 5)",
            "bucket(x, 5)": "bucket(-\"index\" % 80, 5)"
        },
        "aggregates": {}
    },
    {
        "plugin": "Y Line",
        "plugin_config": {},
        "title": "Max Headroom",
        "group_by": ["x"],
        "split_by": ["y"],
        "columns": ["New Column 2"],
        "filter": [["x", "<", 0.0]],
        "sort": [],
        "expressions": {
            "x": "-\"index\" % 80",
            "y": "floor(\"index\" / 80)",
            "New Column 2": "-floor(\"index\" / 80) * 20 - \"color\""
        },
        "aggregates": {
            "New Column 2": "avg"
        }
    },
    {
        "plugin": "X/Y Scatter",
        "plugin_config": {},
        "title": "Scatter Cam",
        "group_by": ["x", "y"],
        "split_by": [],
        "columns": ["x", "New Column 2", "color", null, null, null, null],
        "filter": [["x", "<", 0.0]],
        "sort": [],
        "expressions": {
            "New Column 2": "-floor(\"index\" / 80) * 50 - \"color\"",
            "x": "-\"index\" % 80",
            "y": "floor(\"index\" / 80)"
        },
        "aggregates": {
            "x": "avg",
            "New Column 2": "avg"
        },
        "columns_config": {
            "color": {
                "gradient": "linear-gradient(to right, #ff0000 0%, #ffff00 10%, #00ff00 20%, #00ffff 30%, #0000ff 40%, #000080 50%, #0000ff 60%, #00ffff 70%, #00ff00 80%, #ffff00 90%, #ff0000 100%)"
            }
        }
    },
    {
        "plugin": "Datagrid",
        "plugin_config": {
            "editable": false,
            "scroll_lock": false
        },
        "title": "Raw Stream",
        "group_by": [],
        "split_by": [],
        "columns": ["index", "color"],
        "filter": [],
        "sort": [],
        "expressions": {},
        "aggregates": {}
    },
    {
        "plugin": "Density",
        "plugin_config": {
            "gradient_intensity": 1,
            "gradient_radius_px": 42
        },
        "title": "Density Cam",
        "expressions": {
            "y": "-floor(\"index\" / 80)",
            "x": "-\"index\" % 80"
        },
        "columns": ["x", "y", "color", null],
        "aggregates": {
            "y": "any",
            "x": "any"
        },
        "columns_config": {
            "color": {
                "gradient": "linear-gradient(to right, #00007f 0%, #0000ff 12.5%, #007fff 25%, #00ffff 37.5%, #7fff7f 50%, #ffff00 62.5%, #ff7f00 75%, #ff0000 87.5%, #7f0000 100%)"
            }
        }
    }
]
